import { Image } from 'primereact/image';
import { classveewLogo } from '../../assets/images';
export interface ErrorPageLayoutProps {
  title: string;
  code: string;
  message: string;
  showLogo?: boolean;
  image: React.ReactNode;
  children: React.ReactNode;
}

const ErrorPageLayout: React.FC<ErrorPageLayoutProps> = ({
  title,
  code,
  message,
  image,
  children,
  showLogo = false,
}) => {
  return (
    <div className="bg-gray-50 min-h-screen flex flex-col items-center justify-center text-center p-6">
      <div className="bg-white p-8 sm:p-10 rounded-xl shadow-lg max-w-md w-full">
        {showLogo && (
          <div className="mb-6 flex justify-center items-center h-50 w-100">
            <Image src={classveewLogo} alt="image" width="100%" />
          </div>
        )}
        <div className="mb-6 flex justify-center items-center w-32 h-32 mx-auto">{image}</div>
        <h1 className="text-6xl font-bold primary-color">{code}</h1>
        <h2 className="text-2xl font-semibold text-gray-800 mt-4">{title}</h2>
        <p className="text-gray-600 mt-2">{message}</p>
        <div className="mt-6">{children}</div>
      </div>
    </div>
  );
};

export default ErrorPageLayout;
